/* eslint-disable @typescript-eslint/no-explicit-any -- existing annotations; retyping would change compile behavior */
import * as S from './index.styled';
import { ReactComponent as PlusIcon } from '../../../../../../../../assets/icons/phosphor-plus.svg';
import {
    Outlet,
    useLocation,
    useMatch,
    useNavigate,
    useParams,
    useResolvedPath,
} from 'react-router-dom';
import { Modal, Fade, IconButton, SvgIcon, Typography } from '@mui/material';
import { useCallback, useEffect, useState } from 'react';
import PrimaryButton from 'components/common/PrimaryButton/PrimaryButton';
import styles from './ClientProfile.module.scss';
import { ReactComponent as CrossSimpleIcon } from 'assets/icons/cross-simple.svg';
import { formCounterSlice } from 'redux/formCounter';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from 'redux/store';
import api from 'api';
import { VisaPurposeServerValues } from 'data/constants/constants';
import { NavLinkType } from './components/DropdownMenuNavLink/DropdownMenuNavLink';
import { loadApplications } from 'redux/applications/applications-middleware';
import CreateCase from 'views/v2/Dashboards-B2B/components/backOfficeFlow/case/containers/createCase';
import { setSalesCurrentClient } from 'redux/sales-clients/sales-clients.slice';
import SelectFormPageDropdown from './components/Dropdowns/SelectFormPageDropdown';
import SelectCaseDropdown from './components/Dropdowns/SelectCaseDropdown';
import { Program } from './components/Results/Results';
import SelectRetainerTypeDropdown from 'views/Dashboards-B2B/components/select-retainer-type-dropdown/SelectRetainerTypeDropdown';
import AgreementSignatureB2B from 'components/common/AgreementSignature/AgreementSignature';
import AssessmentAgreementSignature from 'components/common/AgreementSignature/AssessmentAgreementSignature';
import { useTranslation } from 'react-i18next';
import { HeaderMainSection } from 'views/Dashboards-B2B/components/BACKOFFICEFLOW/CLIENTVIEW/ClientView.styled';
import { OnboardingSearchbarContainer } from 'views/Dashboards-B2B/Dashboard.styled';
import { useWindowSize } from 'hooks/useWindowSize';
import {
    ModalWrapper,
    Modal1,
    BtnWrapper,
    IconBtn1,
    CrossSimpleIcon1,
} from '../../../../../CLIENTFLOW/agreement/Agreement.styled';
import Button from 'views/Dashboards-B2B/components/Button';
import { Client } from 'api/models/response/ClientList';
import SelectClientSearchBar from 'views/Dashboards-B2B/components/BACKOFFICEFLOW/CLIENTVIEW/components/ClientProfile/components/SelectClientSearchBar';
import { BiTrash } from 'react-icons/bi';
import AssessmentDownloadModal from '../../../../shared/AssessmentDownloadModal/AssessmentDownloadModal';
import { useFormPath } from 'utils/useFormPath';
import { addPageNumbersToPdf } from '../../../../../../../../utils/pdfHelpers';

interface Entry {
    purpose: string;
}

export const entryUser: Entry = {
    purpose: '',
};

export default function SalesIndex() {
    const { language_setting: language } = useSelector((state: RootState) => state.user.entity);
    const { t } = useTranslation();
    const { entity: activeApp } = useSelector((state: RootState) => state.application);
    const navigate = useNavigate();
    const location = useLocation();
    const { purpose, screen } = useSelector((state: RootState) => state.formCounter);
    const { setPurpose, set } = formCounterSlice.actions;
    const dispatch = useDispatch<AppDispatch>();

    const [formOptions, setFormOptions] = useState<any>([]);
    const [selectedForm, setSelectedForm] = useState('');
    const [selectedCase, setSelectedCase] = useState(t('selectCase', { lng: language }));
    const [retainerType, setSelectedRetainerType] = useState(t('selectType', { lng: language }));
    const PlaceholderOption = {
        firstname: language === 'FR' ? 'Rechercher' : 'Search',
        id: 0,
        lastname: language === 'FR' ? 'des clients' : 'Clients',
        profile_picture_id: 0,
    };

    const [selectedOption, setSelectedOption] = useState<Client>(PlaceholderOption);
    const { id: candidateID, appID } = useParams();
    const [results, setResults] = useState<Program[]>([]);
    const [isContractModalOpen, setContractModalOpen] = useState<boolean>(false);
    const [isAssessmentContractModalOpen, setAssessmentContractModalOpen] =
        useState<boolean>(false);
    const [isFullscreenModeContractModal, setFullscreenModeContractModal] = useState<boolean>(true);
    const [assessmentAgreementSigned, setAssessmentAgreementSigned] = useState<boolean>(false);
    const [width, height] = useWindowSize();
    const [mobile, setMobile] = useState(false);
    const [customStyleForSearchbar, setCustomStyleForSearchbar] = useState(false);
    const resolvedOnboarding = useResolvedPath('');
    const resolvedAssessment = useResolvedPath('assessment');
    const isAgreementPage = location.pathname.includes('/agreement');
    const includesAssessmentPath = location.pathname.includes('/assessment');
    const isResultsPage = location.pathname.includes('/results');
    const isOpportunitiesPage = location.pathname.includes('/opportunities');

    const matchAssessment = useMatch({ path: resolvedAssessment.pathname, end: true });
    const isAssessmentPage = matchAssessment ? true : false;
    const matchCaseStatus = useMatch({ path: resolvedOnboarding.pathname, end: true });
    const isOnboardingPage = matchCaseStatus ? true : false;

    const retainerDropdownElement = document.getElementById('retainer-dropdown');
    let matchingWidth = '';

    if (retainerDropdownElement !== null) {
        matchingWidth = window.getComputedStyle(retainerDropdownElement).getPropertyValue('width');
    }

    useEffect(() => {
        if (width >= 769) {
            setMobile(false);
        }
        if (width < 769) {
            setMobile(true);
        }
    }, [width, height]);

    useEffect(() => {
        if (width >= 1120) {
            setCustomStyleForSearchbar(false);
        }
        if (width < 1120) {
            setCustomStyleForSearchbar(true);
        }
    }, [width, height]);

    const fetchIsAssessmentAgreementSignedData = async (id: string) => {
        try {
            const response = await api.assessmentAgreement.getAssessmentAgreementByClientId(id);
            response.data.candidate_signed_date
                ? setAssessmentAgreementSigned(true)
                : setAssessmentAgreementSigned(false);
        } catch (e) {
            console.error(e);
        }
    };

    useEffect(() => {
        //! reset applications
        if (candidateID) {
            fetchIsAssessmentAgreementSignedData(candidateID);
            setSelectedCase(t('selectCase', { lng: language }));
            setSelectedRetainerType(t('selectType', { lng: language }));
        }
        //eslint-disable-next-line
    }, [candidateID]);

    useEffect(() => {
        if (candidateID) {
            getClient(Number(candidateID));
        } else {
            setSelectedOption(PlaceholderOption);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location, candidateID]);

    const getClient = async (id: number) => {
        try {
            const resp = await api.clientList.getClientById(id);
            if (resp.status === 200 || resp.status === 201) {
                setSelectedOption(resp.data);
            }
        } catch (err) {
            console.error(err);
        }
    };

    const title = isOnboardingPage
        ? t('clientOnboarding', { lng: language })
        : isAssessmentPage
          ? t('visaAssessment', { lng: language })
          : isAgreementPage
            ? t('retainerAgreement', { lng: language })
            : isOpportunitiesPage
              ? t('clients', { lng: language })
              : t('results', { lng: language });

    const note = isAssessmentPage
        ? t('pleaseSelectClient', { lng: language })
        : t('pleaseSelectClient&Retainer', { lng: language });

    const getFrenchPath = (path: string[]) => {
        const translations: { [key: string]: string } = {
            'Personal Info': 'Informations personnelles',
            'Additional Details': 'Détails supplémentaires',
            'Language Proficiency': 'Maîtrise de la langue',
            Education: 'Éducation',
            'Work Experience': "L'expérience professionnelle",
            'Job Offer': "Offre d'emploi",
            'Relatives Abroad': "Parents à l'étranger",
            'Business Ownership': "Propriété de l'entreprise",
            'Spouse/Common Law Partner': 'Époux/conjoint de fait',
            'Family Members': 'Membres de la famille',
        };

        for (let i = 0; i < path.length; i++) {
            if (path[i] in translations) {
                path[i] = translations[path[i]];
            }
        }

        return path;
    };

    const formPath = useFormPath(purpose, candidateID, language);
    useEffect(() => {
        if (language === 'FR') {
            setFormOptions(getFrenchPath(formPath));
        } else {
            setFormOptions(formPath);
        }
    }, [formPath, purpose, candidateID, language]);

    const getScreenNumber = (val: string, purpose: string) => {
        const indices = formPath?.indexOf(val);
        return indices;
    };

    const handleFormChange = (val: any) => {
        if (isResultsPage) {
            navigate(`assessment/${candidateID}`);
        }
        let screenNumber;
        setSelectedForm(val);
        if (purpose) {
            screenNumber = getScreenNumber(val, purpose) + 1;
        } else {
            screenNumber = getScreenNumber(val, '') + 1;
        }

        dispatch(set(screenNumber));
    };

    const loadData = (data: Entry) => {
        if (data.purpose) {
            const indexOfS = Object.values(VisaPurposeServerValues).indexOf(
                data.purpose as unknown as VisaPurposeServerValues
            );
            const key = Object.keys(VisaPurposeServerValues)[indexOfS];
            dispatch(setPurpose(key));
        }
    };

    useEffect(() => {
        if (Number(candidateID) && isAssessmentPage) {
            api.tableInput.fetchCandidateInput(loadData, 'Purpose', Number(candidateID));
        }

        if (candidateID && isAgreementPage) {
            dispatch(loadApplications(candidateID));
        }
        fetchBestScoreAssessmentResults();
        resetScreenNumber();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [candidateID]);

    const resetScreenNumber = () => {
        if (candidateID) {
            setSelectedForm(formOptions[0]);
        } else {
            setSelectedForm('');
        }
        const screenNumber = 1;
        dispatch(set(screenNumber));
    };

    useEffect(() => {
        const currentFormName = formOptions[screen - 1];
        setSelectedForm(currentFormName);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [screen]);

    const [open, setOpen] = useState(false);
    const handleOpen = async () => {
        setOpen(true);
    };
    const handleClose = () => setOpen(false);

    const [isDeleteModalOpen, setDeleteModalOpen] = useState(false);
    const handleDeleteOpen = async () => {
        setDeleteModalOpen(true);
    };
    const handleDeleteClose = () => setDeleteModalOpen(false);

    //agrement-open case

    const [dropdownMenuPrograms, setDropdownMenuPrograms] = useState<NavLinkType[]>([]);
    const { applications: clientApps } = useSelector((state: RootState) => state.applications);

    const [newCaseBtnDisplay, setNewCaseBtnDisplay] = useState<boolean>(false);
    const [completedForms, setCompletedForms] = useState<Record<string, boolean>>({});
    const [fetchingCompletedForms, setFetchingCompletedForms] = useState(false);

    useEffect(() => {
        checkOpenCase();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dropdownMenuPrograms]);

    const checkOpenCase = () => {
        const hasOpenCase = dropdownMenuPrograms.some((item) => item.name === 'Open Case');
        setNewCaseBtnDisplay(!hasOpenCase);
    };

    const getCompletedForms = useCallback(async () => {
        if (fetchingCompletedForms || !candidateID) return;

        setFetchingCompletedForms(true);
        const resp = await api.completedForms.getCompletedForms(+candidateID);
        if (resp?.data) {
            setCompletedForms(resp.data);
        }
        setFetchingCompletedForms(false);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [candidateID]);

    useEffect(() => {
        getCompletedForms();
    }, [candidateID, selectedForm, getCompletedForms]);

    useEffect(() => {
        const convertedData = clientApps.map<NavLinkType>((app) => ({
            id: app.id.toString(),
            name: app.program_name,
            path: `agreement/${candidateID}/visa-program/${app.id.toString()}`,
        }));
        setDropdownMenuPrograms(convertedData);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [clientApps]);

    useEffect(() => {
        if (candidateID) {
            dispatch(setSalesCurrentClient({ clientID: candidateID }));
            return;
        }
        dispatch(setSalesCurrentClient({ clientID: null }));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [candidateID]);

    useEffect(() => {
        if (dropdownMenuPrograms.length > 0) {
            if (candidateID && appID) {
                const browserSelectedApp = dropdownMenuPrograms?.filter(
                    (app: any) => String(app.id) === appID
                );
                if (browserSelectedApp) {
                    setSelectedCase(browserSelectedApp[0]?.name);
                }
            } else {
                setSelectedCase(t('selectCase', { lng: language }));
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location, appID, dropdownMenuPrograms]);

    const fetchBestScoreAssessmentResults = async () => {
        setResults([]);
        try {
            if (candidateID) {
                const res = await api.assessment.getTopScore(candidateID);
                const canadaResults = res.data.find((item: any) => item.country === 'Canada');
                if (canadaResults) {
                    setResults([canadaResults]);
                } else {
                    setResults([]);
                }
            }
        } catch (e) {
            console.error(e);
        }
    };
    const openCloseContractModal = () => {
        setContractModalOpen((state) => !state);
    };
    const openCloseAssessmentContractModal = () => {
        setAssessmentContractModalOpen((state) => !state);
    };

    const handleAgreementFullscreenMode = (value: boolean) => {
        setFullscreenModeContractModal(value);
    };
    const [pdfDoc, setPdfDoc] = useState<string | null>(null);

    const downloadAssessment = async (id: string, country: string, lang: string) => {
        const resp = await api.assessment.getNewAssessment(Number(id), country, lang);
        const numbered = await addPageNumbersToPdf(resp.data);
        prepareBlobFile(numbered);
    };

    const prepareBlobFile = async (file: Blob) => {
        const pdfBlob = new Blob([file], { type: 'application/pdf' });

        const pdfBase64 = await new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(pdfBlob);
            reader.onload = () => resolve(reader.result as string);
            reader.onerror = (error) => reject(error);
        });

        if (typeof pdfBase64 === 'string') {
            setPdfDoc(pdfBase64);
        }
    };

    useEffect(() => {
        if (pdfDoc) {
            const link = document.createElement('a');
            link.href = pdfDoc;
            link.download = 'assessment_report.pdf';
            link.click();
        }
        setPdfDoc(null);
    }, [pdfDoc]);

    const handleRetainer = (val: string) => {
        setSelectedRetainerType(val);
        if (val === t('eligibilityAssessment', { lng: language }) && candidateID) {
            navigate(`agreement/${candidateID}/AgreementFee`);
        }
        if (val === t('visaApplication', { lng: language }) && candidateID) {
            navigate(`agreement/${candidateID}`);
        }
    };

    const handleDeleteConfirmed = async () => {
        if (activeApp) {
            try {
                await api.assessment.deleteApplication(activeApp.id);
                handleDeleteClose();
                window.location.reload();
            } catch (error) {
                console.error('Failed to delete application:', error);
            }
        }
    };

    const [openCaseProperties, setOpenCaseProperties] = useState<boolean>(false);
    const openCloseCaseProperties = async () => {
        setOpenCaseProperties((prevState) => !prevState);
    };

    const getOpenCaseTemplate = () => {
        return (
            <AssessmentDownloadModal
                open={openCaseProperties}
                closeModal={openCloseCaseProperties}
                handleDownloadReport={downloadAssessment}
            />
        );
    };

    // const [selectedCaseRetainer, setSelectedCaseRetainer] = useState(
    //     t('createNew', { lng: language })
    // );

    return (
        <>
            <HeaderMainSection>
                <Typography
                    variant="h5"
                    sx={{
                        fontWeight: 700,
                        letterSpacing: '-0.02em',
                    }}
                >
                    {title}
                </Typography>
                {/* <S.Title>{title}</S.Title> */}
                {/* {isAgreementPage && (
                            <CustomizedSwitches
                                disabled={
                                    Object.keys(selectedOption).length == 0
                                }></CustomizedSwitches>
                        )} */}

                {retainerType === t('visaApplication', { lng: language }) &&
                    isAgreementPage &&
                    activeApp && (
                        <Button
                            disabled={activeApp.date_offer_sent === null}
                            background={
                                activeApp.date_offer_sent === null
                                    ? 'red'
                                    : activeApp.date_agreement_signed
                                      ? 'purple'
                                      : 'green'
                            }
                            onClick={
                                !activeApp.date_offer_sent
                                    ? () => console.log('no retainer yet')
                                    : openCloseContractModal
                            }
                        >
                            {activeApp.date_offer_sent === null
                                ? t('agreementNotSent', { lng: language })
                                : activeApp.date_agreement_signed
                                  ? t('viewSignedAgreement', { lng: language })
                                  : t('viewSentAgreement', { lng: language })}
                        </Button>
                    )}

                {retainerType === t('visaApplication', { lng: language }) &&
                    isAgreementPage &&
                    activeApp &&
                    activeApp.date_offer_sent &&
                    activeApp.date_agreement_signed && (
                        <IconButton
                            style={{
                                marginLeft: '15px',
                                color: '#282828',
                            }}
                            onClick={handleDeleteOpen}
                        >
                            <SvgIcon
                                style={{
                                    width: '15',
                                    height: '16.7px',
                                }}
                                viewBox="3 5 18 16.7"
                                component={BiTrash}
                                color="error"
                                htmlColor="black"
                            />
                        </IconButton>
                    )}

                {retainerType === t('eligibilityAssessment', { lng: language }) &&
                    candidateID &&
                    isAgreementPage && (
                        <Button
                            background={assessmentAgreementSigned ? 'purple' : 'green'}
                            onClick={openCloseAssessmentContractModal}
                        >
                            {assessmentAgreementSigned
                                ? t('viewSignedAgreement', { lng: language })
                                : t('viewSentAgreement', { lng: language })}
                        </Button>
                    )}
                {includesAssessmentPath && !isResultsPage && results?.length > 0 && (
                    <Button
                        background="purple"
                        border="purple"
                        onClick={() => {
                            navigate(`assessment/${candidateID}/results`);
                        }}
                    >
                        {t('viewReport', { lng: language })}
                    </Button>
                )}
                {isResultsPage && (
                    <>
                        <Button
                            background="purple"
                            border="purple"
                            onClick={openCloseCaseProperties}
                        >
                            {t('downloadReport', { lng: language })}
                        </Button>
                        {getOpenCaseTemplate()}
                    </>
                )}
            </HeaderMainSection>

            {!isOnboardingPage && !isOpportunitiesPage && (
                <OnboardingSearchbarContainer mobile={customStyleForSearchbar}>
                    <SelectClientSearchBar
                        onboarding={true}
                        mobile={mobile}
                        matchingWidth={matchingWidth}
                        currentClient={selectedOption}
                    ></SelectClientSearchBar>

                    {includesAssessmentPath && (
                        <SelectFormPageDropdown
                            onboarding={true}
                            mobile={mobile}
                            customStyleForSearchbar={customStyleForSearchbar}
                            selectedCase={selectedForm}
                            handleSelectedCase={handleFormChange}
                            options={formOptions}
                            completedForms={completedForms}
                        />
                    )}

                    {isAgreementPage && (
                        <>
                            <SelectRetainerTypeDropdown
                                onboarding={true}
                                mobile={mobile}
                                selectedType={retainerType}
                                handleSelectedType={handleRetainer}
                                dropdownMenuPrograms={[
                                    {
                                        name: t('eligibilityAssessment', {
                                            lng: language,
                                        }),
                                    },
                                    {
                                        name: t('visaApplication', {
                                            lng: language,
                                        }),
                                    },
                                ]}
                            />

                            {retainerType === t('visaApplication', { lng: language }) && (
                                <SelectCaseDropdown
                                    mobile={mobile}
                                    onboarding={true}
                                    selectedCase={selectedCase}
                                    handleSelectedCase={setSelectedCase}
                                    dropdownMenuPrograms={dropdownMenuPrograms}
                                />
                            )}
                            {/* {retainerType === t('visaApplication', { lng: language }) && (
                                <GenericSearchableDropdown
                                    label={t('selectRetainer', { lng: language })}
                                    selectedType={selectedCaseRetainer}
                                    handleSelectedType={(value) => {
                                        setSelectedCaseRetainer(value);
                                    }}
                                    dropdownMenuPrograms={[
                                        {
                                            value: t('createNew', {
                                                lng: language,
                                            }),
                                            label: t('createNew', {
                                                lng: language,
                                            }),
                                        },
                                        {
                                            value: t('viewRetainers', {
                                                lng: language,
                                            }),
                                            label: t('viewRetainers', {
                                                lng: language,
                                            }),
                                        },
                                    ]}
                                    purple={true}
                                />
                            )} */}

                            {retainerType === t('visaApplication', { lng: language }) &&
                                newCaseBtnDisplay &&
                                candidateID && (
                                    <PrimaryButton
                                        style={{
                                            lineHeight: '1.2',
                                            whiteSpace: 'nowrap',
                                            justifyContent: 'space-between',
                                            minWidth: matchingWidth ? matchingWidth : 'fit-content',
                                            maxWidth: matchingWidth ? matchingWidth : 'fit-content',
                                            height: '37px',
                                        }}
                                        variant="outlined"
                                        size="min"
                                        color="blue"
                                        fullWidth
                                        onClick={handleOpen}
                                    >
                                        {t('newCase', { lng: language })}{' '}
                                        <PlusIcon className={styles['plus_icon']} />
                                    </PrimaryButton>
                                )}
                        </>
                    )}
                </OnboardingSearchbarContainer>
            )}

            {isAssessmentPage || isAgreementPage ? (
                selectedOption.id !== 0 ? (
                    <Outlet />
                ) : (
                    <S.Container>
                        <S.Body>
                            <S.selectClientTitle>{note}</S.selectClientTitle>
                        </S.Body>
                    </S.Container>
                )
            ) : isResultsPage ? (
                <S.Container>
                    <S.Body>
                        <Outlet />
                    </S.Body>
                </S.Container>
            ) : (
                <Outlet />
            )}

            <CreateCase open={open} onClose={handleClose} />

            <Modal
                sx={{ zIndex: '10000' }}
                open={isContractModalOpen}
                onClose={openCloseContractModal}
            >
                <ModalWrapper fullscreen={isFullscreenModeContractModal}>
                    <Modal1 fullscreen={isFullscreenModeContractModal}>
                        <BtnWrapper>
                            <IconBtn1 onClick={openCloseContractModal}>
                                <CrossSimpleIcon1 />
                            </IconBtn1>
                        </BtnWrapper>
                        <AgreementSignatureB2B
                            appID={activeApp ? activeApp.id.toString() : null}
                            onFullscreenMode={handleAgreementFullscreenMode}
                            onUserSignedAgreement={openCloseContractModal}
                        />
                    </Modal1>
                </ModalWrapper>
            </Modal>

            <Modal
                sx={{ zIndex: '10000' }}
                open={isAssessmentContractModalOpen}
                onClose={openCloseAssessmentContractModal}
            >
                <ModalWrapper fullscreen={isFullscreenModeContractModal}>
                    <Modal1 fullscreen={isFullscreenModeContractModal}>
                        <BtnWrapper>
                            <IconBtn1 onClick={openCloseAssessmentContractModal}>
                                <CrossSimpleIcon1 />
                            </IconBtn1>
                        </BtnWrapper>
                        <AssessmentAgreementSignature
                            isClientFlow={false}
                            userID={
                                selectedOption?.id && selectedOption.id !== 0
                                    ? selectedOption.id.toString()
                                    : null
                            }
                            onFullscreenMode={handleAgreementFullscreenMode}
                            onUserSignedAgreement={openCloseAssessmentContractModal}
                        />
                    </Modal1>
                </ModalWrapper>
            </Modal>

            <Modal open={isDeleteModalOpen} onClose={handleDeleteClose}>
                <Fade in={isDeleteModalOpen}>
                    <S.ModalWrapper>
                        <S.ModalContent>
                            <S.ModalHeader>
                                <S.ModalTitle>
                                    {t('Are you sure that you want to delete this agreement?', {
                                        lng: language,
                                    })}
                                </S.ModalTitle>
                                <S.ModalCloseButton onClick={handleDeleteClose}>
                                    <CrossSimpleIcon />
                                </S.ModalCloseButton>
                            </S.ModalHeader>
                            <S.ModalButtonContainer>
                                <S.ModalButton background="purple" onClick={handleDeleteConfirmed}>
                                    {t('confirm', { lng: language })}
                                </S.ModalButton>
                                <S.ModalButton background="gray" onClick={handleDeleteClose}>
                                    {t('cancel', { lng: language })}
                                </S.ModalButton>
                            </S.ModalButtonContainer>
                        </S.ModalContent>
                    </S.ModalWrapper>
                </Fade>
            </Modal>
        </>
    );
}
